import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { createSelector } from 'reselect';

export default createSelector(
  (state: StoreType) => state.app.activeBusiness,
  (activeBusiness): core.Business | undefined => activeBusiness
);

export const hasPosIntegrationSelector = createSelector(
  (state: StoreType) => state.app.activeBusiness.hasPosIntegration,
  (hasPosIntegration: boolean) => hasPosIntegration
);

export const currentBusinessIdSelector = createSelector(
  (state: StoreType) => state.app.activeBusiness.id,
  (id: number) => id
);

export const maxOccupancySelector = (state: StoreType) => state.app.activeBusiness.maxOccupancy;
